import React from 'react';
import Icon from '../../../components/AppIcon';

const CalendarView = ({ 
  currentDate, 
  selectedDate, 
  onDateSelect, 
  scheduledSessions,
  partnerAvailability 
}) => {
  const getDaysInMonth = (date) => {
    const year = date?.getFullYear();
    const month = date?.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay?.getDate();
    const startingDayOfWeek = firstDay?.getDay();
    
    return { daysInMonth, startingDayOfWeek };
  };

  const { daysInMonth, startingDayOfWeek } = getDaysInMonth(currentDate);
  const days = Array.from({ length: daysInMonth }, (_, i) => i + 1);
  const emptyDays = Array.from({ length: startingDayOfWeek }, (_, i) => i);

  const isToday = (day) => {
    const today = new Date();
    return (day === today?.getDate() &&
    currentDate?.getMonth() === today?.getMonth() && currentDate?.getFullYear() === today?.getFullYear());
  };

  const isSelected = (day) => {
    if (!selectedDate) return false;
    return (day === selectedDate?.getDate() &&
    currentDate?.getMonth() === selectedDate?.getMonth() && currentDate?.getFullYear() === selectedDate?.getFullYear());
  };

  const getSessionForDay = (day) => {
    return scheduledSessions?.find(session => {
      const sessionDate = new Date(session.date);
      return (sessionDate?.getDate() === day &&
      sessionDate?.getMonth() === currentDate?.getMonth() && sessionDate?.getFullYear() === currentDate?.getFullYear());
    });
  };

  const getAvailabilityScore = (day) => {
    const dateKey = `${currentDate?.getFullYear()}-${currentDate?.getMonth() + 1}-${day}`;
    return partnerAvailability?.[dateKey] || 0;
  };

  const getAvailabilityColor = (score) => {
    if (score >= 80) return 'bg-success/20 border-success';
    if (score >= 50) return 'bg-warning/20 border-warning';
    if (score > 0) return 'bg-accent/20 border-accent';
    return '';
  };

  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="grid grid-cols-7 gap-1 md:gap-2 mb-2">
        {weekDays?.map(day => (
          <div 
            key={day} 
            className="text-center text-xs md:text-sm font-medium font-caption text-muted-foreground py-2"
          >
            {day}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1 md:gap-2">
        {emptyDays?.map(i => (
          <div key={`empty-${i}`} className="aspect-square" />
        ))}
        
        {days?.map(day => {
          const session = getSessionForDay(day);
          const availabilityScore = getAvailabilityScore(day);
          const availabilityColor = getAvailabilityColor(availabilityScore);
          
          return (
            <button
              key={day}
              onClick={() => onDateSelect(new Date(currentDate.getFullYear(), currentDate.getMonth(), day))}
              className={`
                aspect-square rounded-md border transition-therapeutic
                flex flex-col items-center justify-center p-1 md:p-2
                ${isSelected(day) 
                  ? 'bg-primary text-primary-foreground border-primary' 
                  : isToday(day)
                  ? 'bg-accent/10 border-accent text-foreground'
                  : availabilityColor
                  ? `${availabilityColor} text-foreground`
                  : 'bg-background border-border text-foreground hover:bg-muted'
                }
              `}
            >
              <span className="text-xs md:text-sm font-medium">
                {day}
              </span>
              {session && (
                <div className="mt-0.5 md:mt-1">
                  <Icon 
                    name="Heart" 
                    size={12} 
                    color={isSelected(day) ? 'var(--color-primary-foreground)' : 'var(--color-accent)'}
                  />
                </div>
              )}
            </button>
          );
        })}
      </div>
      <div className="mt-4 md:mt-6 flex flex-wrap items-center gap-3 md:gap-4 text-xs md:text-sm">
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 rounded border-2 border-success bg-success/20" />
          <span className="text-muted-foreground font-caption">High compatibility</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 rounded border-2 border-warning bg-warning/20" />
          <span className="text-muted-foreground font-caption">Moderate compatibility</span>
        </div>
        <div className="flex items-center space-x-2">
          <div className="w-4 h-4 rounded border-2 border-accent bg-accent/20" />
          <span className="text-muted-foreground font-caption">Low compatibility</span>
        </div>
      </div>
    </div>
  );
};

export default CalendarView;